React = require 'react/addons'
AgeProtectedRoute = require '../mixins/age-protected-route'
Router = require 'react-router'
{ State } = Router
VideoPlayer = require './shared/video-player'
VideoStore = require '../stores/video-store'
ProductStore = require '../stores/product-store'
NavigationActions = require '../actions/navigation'
MediaQuery = require '../mixins/media-query'
ProductVideo = require './shared/product-video'
LightMode = require '../mixins/light-mode'
Link = Router.Link

module.exports = React.createClass
  displayName: 'Product'

  mixins: [AgeProtectedRoute, Router.Navigation, State, MediaQuery]

  getInitialState: ->
    return {
      productIndex: 0
      videoIndex: 0
    }

  updateParamState: ->
    product = null
    productIndex = 0
    videoIndex = 0

    for prod, i in ProductStore.products when prod.key is @getParams().productId
      productIndex = i
      product = prod
      break

    for vid, j in VideoStore.videos when vid.key is product.video
      videoIndex = j
      break

    @setState
      productIndex: productIndex
      videoIndex: videoIndex

  componentWillReceiveProps: ->
    @updateParamState()

  componentWillMount: ->
    NavigationActions.disableAnimations()
    LightMode.componentWillMount()

    @updateParamState()

  componentWillUnmount: ->
    NavigationActions.enableAnimations()

  onNext: ->
    nextIndex = @state.productIndex + 1
    if nextIndex >= ProductStore.products.length then nextIndex = 0

    product = ProductStore.products[nextIndex]
    @transitionTo 'product', { productId: product.key }, { force: true }

  onPrev: ->
    prevIndex = @state.productIndex - 1
    if prevIndex < 0 then prevIndex = ProductStore.products.length - 1

    product = ProductStore.products[prevIndex]
    @transitionTo 'product', { productId: product.key }, { force: true }

  onClose: ->
    product = ProductStore.products[0]
    @transitionTo 'product', { productId: product.key }

  renderMobile: ->
    NavigationActions.lightMode()

    React.createElement("div", {"className": 'products'},
      (
        for product in ProductStore.products
          React.createElement("div", null, React.createElement("h2", null, React.createElement(Link, {"to": 'product', "params": (productId: product.key), "query": (force: true)}, (product.title))), React.createElement("p", null, (product.description)))
      )
    )

  renderDesktop: ->
    product = ProductStore.products[@state.productIndex]
    video = VideoStore.videos[@state.videoIndex]
    onClose = if @state.isMobile then (@onClose) else null

    React.createElement(ProductVideo, {"key": (product.key), "product": (product), "onClose": (onClose), "onNext": (@onNext), "onPrev": (@onPrev), "productIndex": (@state.productIndex), "video": (video), "videoIndex": (@state.videoIndex)})

  render: ->
    if @state.isMobile and not(@getQuery().force) then @renderMobile()
    else @renderDesktop()



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/product.cjsx
 **/